import { jsx as l, jsxs as I } from "react/jsx-runtime";
import { clsx as N } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { useState as R, useEffect as B, useRef as G } from "react";
import { getRovingIndex as f } from "../../utils/roving-index.js";
import { getDisclosureProps as J } from "../../utils/use-disclosure.js";
import { getPrefersReducedMotion as Q } from "../../utils/use-prefers-reduced-motion.js";
import { useScrollActiveItemIntoViewOnMount as W } from "../../utils/use-scroll-active-item-into-view-on-mount.js";
import { useScrollIntoView as X } from "../../utils/use-scroll-into-view.js";
import { RocheUIIcon as D } from "../icon/roche-icon.js";
import n from "./roche-accordion.module.scss.js";
import { RocheUIAccordionAppearance as Y } from "./roche-accordion.types.js";
const Z = (d, o) => {
  var i;
  return o === void 0 || o < 0 || o >= ((d == null ? void 0 : d.length) ?? 0) ? null : ((i = d == null ? void 0 : d[o]) == null ? void 0 : i.id) ?? null;
}, dr = ({
  initiallyOpen: d,
  sections: o,
  headlineLevel: i = "h4",
  children: h,
  slot: P,
  onPanelToggle: s,
  iconVariant: k = "plus-minus",
  openSectionId: u,
  onOpenSectionChange: _,
  scrollToOpenSectionOnMount: y = !1,
  hasMarginTop: E = !0,
  hasBorderTop: U = !0,
  hasBorderBottom: $ = !0,
  appearance: j = Y.DEFAULT
}) => {
  const p = u !== void 0, [C, w] = R(
    () => Z(o, d)
  ), H = p ? u : C, m = (o == null ? void 0 : o.findIndex((c) => c.id === H)) ?? -1;
  B(() => {
    p && w(u ?? null);
  }, [p, u]);
  const [g, b] = R(null), v = G([]), { scrollToItem: K } = X(v);
  W(y && m >= 0, () => {
    K(m);
  });
  const L = (c) => {
    const r = o == null ? void 0 : o[c];
    if (!r)
      return;
    const t = m === c, a = t ? null : r.id;
    p || w(a), b(t && !Q() ? c : null), _ == null || _(a);
  }, M = (c, r) => {
    var a;
    L(r);
    const t = ((a = o == null ? void 0 : o[r]) == null ? void 0 : a.headline) || "";
    s == null || s(c, t);
  }, V = (c, r) => {
    c.propertyName === "grid-template-rows" && g === r && b(null);
  }, F = (c, r) => {
    var A;
    if (!o || o.length === 0)
      return;
    const { key: t } = c, a = o.length, e = {
      ArrowDown: () => f("next", r, a),
      ArrowUp: () => f("previous", r, a),
      Home: () => f("first", r, a),
      End: () => f("last", r, a)
    };
    if (e[t]) {
      c.preventDefault();
      const z = e[t]();
      (A = v.current[z]) == null || A.focus();
    }
  }, T = `${i}`, q = N(n.accordion, n[`accordion--${j}`], {
    [n["accordion--no-margin"]]: !E,
    [n["accordion--no-border-top"]]: !U,
    [n["accordion--no-border-bottom"]]: !$
  });
  return /* @__PURE__ */ l("div", { className: q, slot: P, children: o == null ? void 0 : o.map((c, r) => {
    const { triggerProps: t, panelProps: a } = J(`accordion-${c.id}`, m === r);
    return /* @__PURE__ */ I(
      "div",
      {
        className: N(
          n.accordion__item,
          m === r && n["accordion__item--active"],
          g === r && n["accordion__item--closing"]
        ),
        children: [
          /* @__PURE__ */ l(T, { children: /* @__PURE__ */ I(
            "button",
            {
              className: n.accordion__header,
              type: "button",
              ...t,
              onClick: (e) => M(e, r),
              onKeyDown: (e) => F(e, r),
              ref: (e) => {
                v.current[r] = e;
              },
              children: [
                /* @__PURE__ */ l("span", { className: n["accordion__header-text"], children: c.headline }),
                /* @__PURE__ */ I("span", { className: n["accordion__header-icons"], children: [
                  c.badge != null && /* @__PURE__ */ l("span", { className: n.accordion__badge, children: c.badge }),
                  k === "chevron" ? /* @__PURE__ */ l(
                    "span",
                    {
                      className: N(
                        n.accordion__icon,
                        n["accordion__icon--chevron"],
                        m === r && n["accordion__icon--chevron-open"]
                      ),
                      children: /* @__PURE__ */ l(D, { icon: "chevron-down", height: "24px", decorative: !0 })
                    }
                  ) : /* @__PURE__ */ l("span", { className: n.accordion__icon, children: /* @__PURE__ */ l(D, { icon: m === r ? "minus" : "plus", height: "24px", decorative: !0 }) })
                ] })
              ]
            }
          ) }),
          /* @__PURE__ */ l(
            "div",
            {
              className: n.accordion__panel,
              ...a,
              onTransitionEnd: (e) => V(e, r),
              children: /* @__PURE__ */ l("div", { className: n["accordion__panel-content"], children: h == null ? void 0 : h[r] })
            }
          )
        ]
      },
      c.id
    );
  }) });
};
export {
  dr as RocheUIAccordion
};
